import ErrorPage from "../../screens/Error/ErrorPage";

const errorRoutes = {
  path: "*",
  element: <ErrorPage />,
};

export default errorRoutes;
